export const EntityAccessLevel = {
    FULL: 'FULL',
    LIMITED: 'LIMITED',
    MISSING_PERMISSIONS: 'MISSING_PERMISSIONS',
} as const;

export type EntityAccessLevelType = typeof EntityAccessLevel;
export type EntityAccessLevelTypes = EntityAccessLevelType[keyof EntityAccessLevelType];
